import { getTableSortOrder } from "../../../utils/getTableSortOrder";
import { TableSortTypes } from "../../../enums/ViewListingTypes";
import acceptIcon from "../../../assets/images/accept-icon.svg";
import rejectIcon from "../../../assets/images/reject-icon.svg";
import styles from "./MaterialPriceErrorTable.module.scss";
import { Button } from "antd";

export const MaterialPriceErrorTableConsts = {
  NO_RECORDS: "No affected jobs available",
  NO_RECORDS_FOUND: "No affected jobs found",
  REJECT_MODAL_TITLE: "Keep Old Pricing",
  REJECT_MODAL_OK_TEXT: "Confirm",
  REJECT_MODAL_CANCEL_TEXT: "Cancel",
  NOTES_PLACEHOLDER: "Enter Notes",
  UPLOAD_HELP_TEXT: "Max file size is 5MB.",
};

export const getMaterialPriceErrorColumns = ({
  handleAcceptAction,
  handleRejectAction,
  sortBy,
  sortOrder,
}) => {
  return [
    {
      title: "JOB",
      dataIndex: "jobNumber",
      key: "jobNumber",
      align:"center",
      width: "auto",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "jobNumber"),
      render: (value) => value || "-",
    },
    {
      title: "Job Name",
      dataIndex: "jobName",
      align:"center",
      key: "jobName",
      width: "280px",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "jobName"),
      render: (value) => value || "-",
    },
    {
      title: "CUSTOMER NAME",
      align:"center",
      dataIndex: "companyName",
      key: "companyName",
      width: "280px",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "companyName"),
      render: (value) => value || "-",
    },
    {
      title: "SALES PERSON",
      dataIndex: "salesPerson",
      align:"center",
      key: "salesPerson",
      width: "180px",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "salesPerson"),
      render: (value) => value || "-",
    },
    {
      title: "MATERIAL CATEGORY",
      dataIndex: "category",
      key: "materialCategory",
      width: "180px",
      align:"center",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "materialCategory"),
      render: (value) => value || "-",
    },
    {
      title: "MATERIAL TYPE",
      dataIndex: "subCategory",
      key: "materialType",
      width: "180px",
      align:"center",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "materialType"),
      render: (value) => value || "-",
    },
    {
      title: "MATERIAL",
      dataIndex: "materialName",
      key: "material",
      width: "180px",
      align:"center",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "material"),
      render: (value) => value || "-",
    },
    {
      title: "CURRENT PRICE",
      dataIndex: "materialCost",
      key: "materialCost",
      width: "140px",
      align:"center",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "materialCost"),
      render: (value, record) => (value ? `$${value} \/ ${record.materialCostType}` : "-"),
    },
    {
      title: "UPDATED PRICE",
      dataIndex: "revisedMaterialCost",
      key: "revisedMaterialCost",
      width: "140px",
      align:"center",
      sorter: true,
      sortOrder: getTableSortOrder(sortBy, sortOrder, "revisedMaterialCost"),
      render: (value, record) => (value ? `$${value} \/ ${record.materialCostType}` : "-"),
    },
    {
      title: "",
      key: "actions",
      width: "120px",
      align:"center",
      align: "center",
      render: (_, record) => (
        <div className={styles.actionCell}>
          <Button
            type="button"
            className={styles.acceptButton}
            icon={<img src={acceptIcon} width={28} height={28} />}
            onClick={() => handleAcceptAction(record)}
          />
          <Button
            type="button"
            className={styles.rejectButton}
            icon={<img src={rejectIcon} width={28} height={28} />}
            onClick={() => handleRejectAction(record)}
          />
        </div>
      ),
    },
  ];
};
